import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, timer } from 'rxjs';
import { mergeMap, retryWhen } from 'rxjs/operators';

@Injectable()
export class RetryInterceptorService implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      retryWhen(errors => 
        errors.pipe(
          mergeMap((error: HttpErrorResponse, index: number) => {
            const retryAttempt = index + 1;
            if (error.status >= 500 && error.status < 600 && retryAttempt <= 3) {
              return timer(1000);
            }
            return throwError(error);
          })
        )
      )
    );
  }
}

